

export const Footer = (props) => {
  return (
      <>
      <footer>
      <div className="footer-content">
        <p>&copy; 2024 styleU. All rights reserved.</p>
        <ul className="footer-links">
          <li>
            <a href="#">About</a>
          </li>
          <li>
            <a href="#">Contact</a>
          </li>
          <li>
            <a href="#">Privacy Policy</a>
          </li>
        </ul>
      </div>
    </footer>
      </>
  );
};